import { post } from "../logic/api";

export async function CreateCategory(body) {
  return await post("/api/administration/CreateCategory", body);
}

export async function EditCategory(body) {
  // categoryId - integer 
  // name - string nullable
  // parentCategoryId - integer 
  // prices - array nullable
  //   accountType - enum integer 
  //   serviceType - enum integer 
  //   price - integer 
  return await post("/api/administration/EditCategory", body);
}

export async function DeleteCategory(body) {
  // categoryId - integer 
  return await post("/api/administration/DeleteCategory", body);
}

export async function GetAdvertismentsWaitingForValidation(body) {
  return await post("/api/administration/GetAdvertismentsWaitingForValidation", body);
}

export async function ValidateAdvertisement(body) {
  // advertisementId - integer 
  return await post("/api/administration/ValidateAdvertisement", body);
}

export async function RefuseAdvertisement(body) {
  // advertisementId - integer
  return await post("/api/administration/RefuseAdvertisement", body);
}

export async function DeleteAdvertisement(body) {
  // advertisementId - integer
  return await post("/api/administration/DeleteAdvertisement", body);
}

export async function GetPayments(body) {
  return await post("/api/administration/GetPayments", body);
}

export async function GetUsers(body) {
  // page - integer 
  return await post("/api/administration/GetUsers", body);
}

export async function AddCredits(body) {
  // page - integer
  return await post("/api/administration/AddCredits", body);
}

export async function GetPublishingPackages(body) {
  return await post("/api/administration/GetPublishingPackages", body);
}

export async function CreatePublishingPackage(body) {
  return await post("/api/administration/CreatePublishingPackage", body);
}

export async function DeletePublishingPackage(body) {
  return await post("/api/administration/DeletePublishingPackage", body);
}

export async function GetAdvertismentsWaitingForValidationCount(body) {
  // page - integer
  return await post("/api/administration/GetAdvertismentsWaitingForValidationCount", body);
}
